import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MasterComponent from './MasterComponent';
import * as serviceWorker from './serviceWorker';
import './styles/animate.min.css';
import WebFont from 'webfontloader';
import ReactGA from "react-ga4";
import { getConfig } from './config';

WebFont.load({
    google: {
      families: ['Raleway', 'Nunito+Sans', 'Roboto+Condensed', 'Lora', 'Georgia', 'Rock+Salt', 'sans-serif']
    }
});

ReactGA.initialize(getConfig().GA_ID);  // replace with your ID

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <MasterComponent />
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
